"use client";

import useTranslate from "@app/_hooks/useTranslate";
import Link from "@components/Link";
import { ArrowLeftIcon } from "@ngg/icons";
import type { LayoutSiteinfoFragment } from "@server/gql/graphql";

export default function CheckoutHeader({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  data,
  locale,
}: {
  data?: LayoutSiteinfoFragment | null;
  locale?: string;
}) {
  const t = useTranslate();
  return (
    <header className="sticky top-0 z-30 grid grid-cols-[3rem,auto,3rem] items-center justify-between gap-6 border-b border-grey-150 bg-white md:h-16 lg:grid-cols-[1fr,auto,1fr]">
      <div className="flex flex-1 items-center md:min-w-[140px]">
        <Link locale={locale} className="group px-4 py-4">
          <span className="flex items-center group-hover:underline">
            <ArrowLeftIcon className="text-lg" />
            <span className="all-small-caps hidden whitespace-nowrap pl-1.5 text-sm font-normal uppercase lg:block">
              {t("continueShopping")}
            </span>
          </span>
        </Link>
      </div>
      <Link locale={locale} prefetch={false}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          fetchPriority="high"
          src="/images/no-ga-logo.svg"
          alt="NO GA logo"
          width={128}
          height={40}
          className="h-10 w-full object-contain transition-all duration-300 ease-out lg:h-12"
        />
      </Link>
    </header>
  );
}
